import { useTranslation } from 'react-i18next'

import { Text } from '@reveni-io/reveni-ui'

import LanguageTextInput from '@/configuration/components/LanguageTextInput/LanguageTextInput'
import { errorTypes } from '@/configuration/pages/ConfigurationPage/LogisticsConfiguration/DeliveryMethods/DeliveryMethodDetailConfiguration/constants'

import * as Styles from './styles'

const CustomName = ({ names, languages, onChange, showError }) => {
  const { t } = useTranslation()

  const errorLanguages = showError ? languages.filter(language => !names?.[language]) : []

  const handleChange = (value, language) => {
    onChange({ ...names, [language]: value === '' ? null : value })
  }

  return (
    <Styles.Container id={errorTypes.customNamesEmpty}>
      <Text type="bodyMRegular">
        {t('El nombre público personalizado se mostrará a los clientes en el Portal de devoluciones')}
      </Text>
      <LanguageTextInput
        languages={languages}
        value={names}
        onChange={handleChange}
        validateEmptyOnBlur={false}
        externalErrorLanguages={errorLanguages}
        inputLabel={t('Nombre público personalizado')}
        showInputError
      />
    </Styles.Container>
  )
}

export default CustomName
